import { DEFAULT_SORT } from "@anaconda/core/nft/search/constants"
import { useMolecule } from "bunshi/react"
import { useEffect } from "react"
import { NftSortMoleculeReatom } from "../sort/store.reatom"
import { NftFiltersMoleculeReatom } from "./store.reatom"
import { applyFiltersToSearchQuery } from "./store.reatom"

/**
 * URL persistence hook for NFT filters and sort
 * Moved from atomEffect to hook to avoid "Cannot update during render" errors
 */
export function useUrlPersistence() {
  const { urlFilters } = useMolecule(NftFiltersMoleculeReatom)
  const { sortAtom } = useMolecule(NftSortMoleculeReatom)

  const filters = urlFilters()
  const sort = sortAtom()

  useEffect(() => {
    const url = new URL(window.location.href)
    const search = new URLSearchParams(window.location.search)

    // Persist filters
    if (Object.keys(filters).length) {
      applyFiltersToSearchQuery(filters, search)
    } else {
      search.delete("filters")
    }

    // Persist sort
    const persistedSortValue = sort !== DEFAULT_SORT ? sort : undefined
    if (!persistedSortValue) {
      search.delete("sort")
    } else {
      search.set("sort", persistedSortValue)
    }

    url.search = search.toString()
    window.history.replaceState(null, "", url)
  }, [filters, sort])
}
